/**
 * @file
 * Displays Bass components from the componentList.
 * Mocks an API request to render Placeholder components while request is
 * processing.
 *
 * @TODO: Update all meta info with correct links / images from prod after deploy.
 */

import * as React from 'react';

// Types
import { IDashboardMeta } from '../../types';

// Styles
import './InfoCard.css';

/**
 * InfoCard
 *
 * @props: Metadata of a Bass component.
 */

interface IProps {
  metadata: IDashboardMeta;
  children?: React.ReactChild;
}
const InfoCard: React.FunctionComponent<IProps> = props => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  return (
    <div className="infocard" data-testid="infocard">
      <div className="infocard__info">
        <h2>{props.metadata.nickname}</h2>
        <p>
          <a
            href={props.metadata.exampleImgUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Example image
          </a>
        </p>
        <p>Found on:</p>
        <ul>
          {props.metadata.pageList.map(page => (
            <li key={page}>
              <a href={page}>{page}</a>
            </li>
          ))}
        </ul>
        <p>ComponentName: {props.metadata.componentName}</p>
        <p>RenderId: {props.metadata.renderId}</p>
      </div>
      <div className="infocard__block">{props.children}</div>
    </div>
  );
};

export default InfoCard;
